<template>
  <div :class="classes">
    <ul class="tg-tree--top">
      <tg-tree-card
        v-if="item"
        :item="item"
        :level="1"
        :expand="true"
        :columns="computedColumns"
        @on-toggle="$emit('on-toggle', $event)"
        @on-info-click="handleInfoClick"
        @on-scroll="handleScroll"
        :expandAll="expandAll"
      ></tg-tree-card>
    </ul>
  </div>
</template>

<script>
import TgTreeCard from "@/components/tree/TgTreeCard";

export default {
  components: {
    TgTreeCard
  },
  provide() {
    return {
      tree: this,
      nodes: this.nodes
    };
  },
  data() {
    return {
      nodes: {},
    };
  },
  props: {
    item: Object,
    expandAll: Boolean,
    columns: Array
  },
  computed: {
    computedColumns () {
      return this.columns || [];
    },
    classes() {
      return [
        "tg-tree",
        {
          "tg-tree--expand-all": this.expandAll,
          "is-mobile": this.isMobile
        }
      ];
    },
    topClass() {
      return ["tg-tree--top", "tg-tree-level--1", "group--" + this.item.group];
    }
  },
  methods: {
    handleInfoClick(event) {
      this.$emit("on-info-click", event);
    },
    handleScroll(e) {
      this.$emit('on-scroll', e);
    }
  },
  watch: {
    columns (val) {
      console.log('watch', val);
    }
  }
};
</script>